export default __webpack_public_path__ + "static/media/2194.1d9d1431.png";